import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getOrganizatinsAPI() {
  const url = `${AWS_API_URL}/organizations`;
  return getRequest(url, await authorize());
}
